'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var FocusLock = require('react-focus-lock');
var reactTransitionGroup = require('react-transition-group');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
var dialog = require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../utilities/color.js');
require('date-fns');
require('../../../../utilities/locale.js');
var usePrefersReducedMotion = require('../../../../hooks/use-prefers-reduced-motion.js');
require('../../../../hooks/use-prevent-keyboard-scrolling.js');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('styled-components');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
var fadeIn = require('../../../../styles/transitions/fade-in.js');
var fadeInFromBottom = require('../../../../styles/transitions/fade-in-from-bottom.js');
var fadeInFromLeft = require('../../../../styles/transitions/fade-in-from-left.js');
var fadeInFromRight = require('../../../../styles/transitions/fade-in-from-right.js');
var fadeInFromTop = require('../../../../styles/transitions/fade-in-from-top.js');
var dialog$1 = require('./components/dialog.js');
var dialogBackground = require('./components/dialog-background.js');
var dialogBody = require('./components/dialog-body.js');
var dialogFooter = require('./components/dialog-footer.js');
var dialogHeader = require('./components/dialog-header.js');
var dialogInner = require('./components/dialog-inner.js');
var dialogOverlay = require('./components/dialog-overlay.js');
var dialogType = require('./components/dialog-type.js');
var dialogWrapper = require('./components/dialog-wrapper.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var FocusLock__default = /*#__PURE__*/_interopDefaultCompat(FocusLock);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * An accessible dialog component for creating modals or drawers.
 * A dialog should only be used when we need to stop the user from interacting with the rest of the application
 * (think hard about this as it has accessibility implications... don't use a dialog if at all possible).
 * Accessibility requirements can be found at https://www.w3.org/TR/wai-aria-practices-1.2/#dialog_modal
 * @param {BaseDialogProps} props BaseDialogProps
 */ const BaseDialog = (props)=>{
    const { animation , autoFocus =true , beforeClose , children , className , closeOnBackgroundClick =true , contentCentered , dialogBackgroundProps , dialogBodyProps , dialogFooterProps , dialogHeaderProps , dialogInnerProps , dialogOverlayProps , dialogProps , dialogTypeProps , dialogWrapperProps , focusLock =true , focusLockProps , footer , header , height , id , labels , loading , next , onClose , open , prev , setOpen , showClose =true , showFooter =true , showTitle =true , size =dialog.DialogSizes.Auto , title , titleIcon , transitionDelay =0 , transitionDuration =300 , type =dialog.DialogTypes.Modal , width  } = props;
    const { closeButtonLabel , loaderLabel  } = labels;
    const prefersReducedMotion = usePrefersReducedMotion.usePrefersReducedMotion();
    const nodeRef = React.useRef(null);
    const [isMounted, setIsMounted] = React.useState(false);
    /**
   * toggles "dialog-open" CSS class, which is needed to add overflow: hidden on the body element.
   * This prevents vertical scrolling and makes background content inert in accordance with w3c guidelines.
   * https://www.w3.org/TR/wai-aria-practices-1.2/#dialog_modal
   * @returns {void} void
   */ // eslint-disable-next-line unicorn/consistent-function-scoping
    const updateBodyClass = (action)=>{
        const body = document.querySelectorAll('body');
        if (body.length > 0 && action === 'close' && body[0].classList.contains('dialog-open')) {
            body[0].classList.remove('dialog-open');
        }
        if (body.length > 0 && action === 'open' && !body[0].classList.contains('dialog-open')) {
            body[0].classList.add('dialog-open');
        }
    };
    /**
   * Closes, the dialog, removes "dialog-open" CSS class and calls the onClose callback.
   * @returns {void} void
   */ const close = ()=>{
        // setOpen should be first
        setOpen(false);
        if (onClose) {
            onClose();
        }
        updateBodyClass('close');
    };
    /**
   * If beforeClose is passed as a prop, closes the dialog only if it returns true.
   * @returns {void} void
   */ const handleClose = (forceClose)=>{
        if (beforeClose && !forceClose) {
            const shouldClose = beforeClose();
            if (shouldClose) {
                close();
            }
        } else {
            close();
        }
    };
    /**
   * It is required dialogs should close on escape. DO NOT REMOVE.
   * https://www.w3.org/TR/wai-aria-practices-1.2/#dialog_modal
   * @param {KeyboardEvent} e KeyboardEvent
   * @returns {void} void
   */ const handleCloseOnEsc = (e)=>{
        if (e.key === 'Escape') {
            handleClose();
        }
    };
    React.useEffect(()=>{
        // DO NOT REMOVE
        setIsMounted(true); // ensures component is mounted before enabling CSSTransition, otherwise CSSTransition classes are not added correctly
        window.addEventListener('keyup', handleCloseOnEsc);
        return ()=>{
            window.removeEventListener('keyup', handleCloseOnEsc);
            handleClose();
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    React.useEffect(()=>{
        if (open) {
            updateBodyClass('open');
        }
        if (!open && isMounted) {
            handleClose(true);
        }
    }, [
        open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const ariaLabelledBy = `${id}-label`;
    const animate = animation || (type === dialog.DialogTypes.Modal ? dialog.DialogAnimations.FadeInFromTop : dialog.DrawerAnimations.FadeInFromRight);
    const timeout = transitionDelay ? transitionDelay + transitionDuration : transitionDuration;
    const renderInner = ()=>/*#__PURE__*/ React__default.default.createElement(React__default.default.Fragment, null, !!prev && prev, /*#__PURE__*/ React__default.default.createElement(dialogInner.DialogInner, _extends({}, dialogInnerProps), /*#__PURE__*/ React__default.default.createElement(dialogHeader.DialogHeader, _extends({}, dialogHeaderProps, {
            closeButtonLabel: closeButtonLabel,
            handleClose: handleClose,
            id: ariaLabelledBy,
            showClose: showClose,
            showTitle: showTitle,
            title: title,
            titleIcon: titleIcon
        }), header), /*#__PURE__*/ React__default.default.createElement(dialogBody.DialogBody, _extends({}, dialogBodyProps, {
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus: autoFocus,
            contentCentered: contentCentered,
            loaderLabel: loaderLabel,
            loading: loading
        }), children), showFooter && /*#__PURE__*/ React__default.default.createElement(dialogFooter.DialogFooter, _extends({}, dialogFooterProps), footer)), !!next && next);
    return /*#__PURE__*/ React__default.default.createElement(reactTransitionGroup.Transition, {
        appear: isMounted && open,
        in: isMounted && open,
        mountOnEnter: true,
        nodeRef: nodeRef,
        timeout: timeout,
        unmountOnExit: true
    }, (transitionStatus)=>{
        return /*#__PURE__*/ React__default.default.createElement(dialog$1.Dialog, _extends({}, dialogProps, {
            className: classnames__default.default({
                [`${className}`]: !!className,
                [`${dialogProps?.className}`]: !!dialogProps?.className
            }),
            ref: nodeRef
        }), /*#__PURE__*/ React__default.default.createElement(dialogWrapper.DialogWrapper, _extends({}, dialogWrapperProps), /*#__PURE__*/ React__default.default.createElement(dialogType.DialogType, _extends({}, dialogTypeProps, {
            animation: animate,
            "aria-labelledby": ariaLabelledBy,
            height: height,
            id: id,
            size: size,
            style: {
                ...dialogTypeProps?.style,
                ...!prefersReducedMotion && animate === dialog.DialogAnimations.FadeIn && fadeIn.transitionFadeIn({
                    transitionDelay,
                    transitionDuration,
                    transitionStatus
                }),
                ...!prefersReducedMotion && animate === dialog.DialogAnimations.FadeInFromBottom && fadeInFromBottom.transitionFadeInFromBottom({
                    transitionDelay,
                    transitionDuration,
                    transitionStatus
                }),
                ...!prefersReducedMotion && animate === dialog.DialogAnimations.FadeInFromLeft && fadeInFromLeft.transitionFadeInFromLeft({
                    transitionDelay,
                    transitionDuration,
                    transitionStatus
                }),
                ...!prefersReducedMotion && animate === dialog.DialogAnimations.FadeInFromRight && fadeInFromRight.transitionFadeInFromRight({
                    transitionDelay,
                    transitionDuration,
                    transitionStatus
                }),
                ...!prefersReducedMotion && animate === dialog.DialogAnimations.FadeInFromTop && fadeInFromTop.transitionFadeInFromTop({
                    transitionDelay,
                    transitionDuration,
                    transitionStatus
                })
            },
            type: type,
            width: width
        }), focusLock ? /*#__PURE__*/ React__default.default.createElement(FocusLock__default.default, _extends({}, focusLockProps, {
            className: classnames__default.default({
                'bf-dialog__focus-lock': true,
                [`${focusLockProps?.className}`]: !!focusLockProps?.className
            }),
            crossFrame: focusLockProps?.crossFrame || false
        }), renderInner()) : renderInner()), closeOnBackgroundClick && /*#__PURE__*/ React__default.default.createElement(dialogBackground.DialogBackground, _extends({}, dialogBackgroundProps, {
            handleClose: handleClose,
            id: id
        }))), /*#__PURE__*/ React__default.default.createElement(dialogOverlay.DialogOverlay, _extends({}, dialogOverlayProps, {
            size: size,
            style: {
                ...dialogOverlayProps?.style,
                ...!prefersReducedMotion && fadeIn.transitionFadeIn({
                    transitionDelay,
                    transitionDuration,
                    transitionStatus
                })
            }
        })));
    });
};

exports.BaseDialog = BaseDialog;
//# sourceMappingURL=base-dialog.js.map
